import { render, staticRenderFns } from "./DeveloperList.vue?vue&type=template&id=f40228a2"
import script from "./DeveloperList.vue?vue&type=script&lang=js"
export * from "./DeveloperList.vue?vue&type=script&lang=js"
import style0 from "./DeveloperList.vue?vue&type=style&index=0&id=f40228a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports